import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.pale,
  fontColor: colors.charcoalGrey,
  textColorDark: colors.charcoalGrey,
  textColorLight: colors.white
};
export default promoBanner;